import React from 'react'
import { minorScale, majorScale, defaultTheme } from 'evergreen-ui'
import CircleIconWrapper from 'components/Icons/CircleIconWrapper'
import OriginalDestinationIcon from 'components/Icons/Destinations'

const DestinationIcon = () => (
  <CircleIconWrapper
    background="greenTint"
    margin={0}
    size={majorScale(3)}
    icon={
      <OriginalDestinationIcon
        width={minorScale(3)}
        height={minorScale(3)}
        fill={defaultTheme.palette.green.base}
      />
    }
  />
)

export default DestinationIcon
